import { Button } from "antd";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import ResNavBar from "../../components/ResNavBar/ResNavBar";
import localization from '../../Localization/Localization.json'
import placecart from "../../assets/place-cart.png"

import "./OrderDone.scss" 
import { connect } from "react-redux";
class OrderDone extends Component {
  render() {
      const {currentLang, location} = this.props;
    return (
      <div className="order-page-wrapper">
        <Header /> 
        <div className="container">
          <div className="order-content-wrapper">
            <div className="order-main"> 
                <p className="order-thank">{localization.Thanks[currentLang]}</p>
                <img src={placecart} alt="" />
                <p className="order-placed-p">
                {localization.Yourorderplacedsuccessfully[currentLang]}
                </p>
                <p className="order-placed-p">
                {localization.youtrackorderstate[currentLang]}
                </p>
                <div className="order-placed-btns">
                    <Button type="primary" size="large" className="mr-20">   
                        <Link to={`/profile/3/${localization.ordrers[currentLang]}/${this.props.location?.state?.orderID}`}>{localization.Trackorder[currentLang]}</Link>
                    </Button>
                    <Button type="primary" size="large" ghost> 
                        <Link to="/">{localization.ContinueShopping[currentLang]}</Link> 
                    </Button>
                </div>
            </div>
          </div>
        </div>
        <Footer /> 
        <ResNavBar /> 
      </div>
    );
  }
}
const OrderDoneWithRouter = withRouter(OrderDone); 
const mapStateToProps = (state) => ({
    currentLang : state.user.currentLang,
});
  
export default connect(mapStateToProps)(OrderDoneWithRouter);
